export default __webpack_public_path__ + "static/media/sofa-1-seat-2-back.a215b2c0.webp";